import React from "react";
import { Typography, Slider } from "@mui/material";

const COMPACT_SLIDER_SX = {
  color: "var(--org-bg-color, #f6615f)",

  "& .MuiSlider-rail": {
    height: 5,
    borderRadius: 999,
    opacity: 1,
    backgroundColor: "#FFEAEA",
  },

  "& .MuiSlider-track": {
    height: 5,
    borderRadius: 999,
    border: "none",
    backgroundColor: "var(--org-bg-color, #f6615f)",
  },

  "& .MuiSlider-thumb": {
    width: 18,
    height: 18,
    backgroundColor: "#fff",
    border: "1px solid #ececec",
    boxShadow: "none",

    "&:hover": {
      boxShadow: "none",
    },

    "&.Mui-focusVisible": {
      boxShadow: "none",
    },

    "&:before": {
      display: "none",
    },

    "&:after": {
      content: '""',
      width: 5,
      height: 5,
      borderRadius: "50%",
      backgroundColor: "#FFD4D4",
      position: "absolute",
    },
  },

  "& .MuiSlider-mark": {
    width: "1px",
    height: "6px",
    backgroundColor: "#777",
    top: 14,
  },

  "& .MuiSlider-markActive": {
    backgroundColor: "#777",
  },
};

const DEFAULT_SLIDER_SX = {
  color: "var(--org-bg-color, #f6615f)",
  px: 0.5,

  "& .MuiSlider-rail": {
    height: 6,
    borderRadius: 999,
    opacity: 1,
    backgroundColor: "#FFEAEA",
  },

  "& .MuiSlider-track": {
    height: 6,
    borderRadius: 999,
    border: "none",
    backgroundColor: "var(--org-bg-color, #f6615f)",
  },

  "& .MuiSlider-thumb": {
    width: 20,
    height: 20,
    backgroundColor: "#fff",
    border: "1px solid #ececec",
    boxShadow: "none",

    "&:hover": {
      boxShadow: "none",
    },

    "&.Mui-focusVisible": {
      boxShadow: "none",
    },

    "&:before": {
      display: "none",
    },

    "&:after": {
      content: '""',
      width: 6,
      height: 6,
      borderRadius: "50%",
      backgroundColor: "#FFD4D4",
      position: "absolute",
    },
  },

  "& .MuiSlider-mark": {
    width: "1px",
    height: "8px",
    borderRadius: "1px",
    backgroundColor: "#7A7A7A",
    top: 16,
  },

  "& .MuiSlider-markActive": {
    backgroundColor: "#7A7A7A",
  },

  "& .MuiSlider-valueLabel": {
    display: "none",
  },
};

const formatTimeRangeLabel = (timeRange) =>
  `${String(timeRange[0]).padStart(2, "0")}:00 - ${
    timeRange[1] === 24
      ? "23:59"
      : `${String(timeRange[1]).padStart(2, "0")}:59`
  }`;

const TimeOfDaySlider = ({
  label,
  timeRange,
  onChange,
  variant = "default",
}) => {
  const isCompact = variant === "compact";
  const wrapperClass = isCompact ? "bg-white p-2 rounded-3" : "rounded-4 bg-white p-2";
  const headerClass = isCompact
    ? "d-flex justify-content-between align-items-center mb-2"
    : "mb-2 flex items-center justify-between";
  const labelFontSize = isCompact ? "12px" : "13px";

  return (
    <div className={wrapperClass}>
      <div className={headerClass}>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 600,
            color: "#4B4E5D",
            lineHeight: 1.2,
          }}
        >
          {label}
        </Typography>

        <Typography
          sx={{
            fontSize: labelFontSize,
            fontWeight: 500,
            color: "var(--org-bg-color, #f6615f)",
            fontFamily: "monospace",
          }}
        >
          {formatTimeRangeLabel(timeRange)}
        </Typography>
      </div>

      <Slider
        value={timeRange}
        onChange={(_, value) => onChange(value)}
        min={0}
        max={24}
        step={1}
        valueLabelDisplay="off"
        marks={Array.from({ length: 25 }, (_, i) => ({
          value: i,
        }))}
        sx={isCompact ? COMPACT_SLIDER_SX : DEFAULT_SLIDER_SX}
      />
    </div>
  );
};

export default TimeOfDaySlider;
